import { render, staticRenderFns } from "./RelatorioCobranca.vue?vue&type=template&id=22a1a2c4&scoped=true"
import script from "./RelatorioCobranca.vue?vue&type=script&lang=js"
export * from "./RelatorioCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1a2c4",
  null
  
)

export default component.exports